import React, { useEffect } from "react";
import styled from "styled-components";
import { useGetPokemons } from "../Hooks/useGetPokemons";
import { useInView } from "react-intersection-observer";
import PokeCard from "./PokeCard";
import { ClipLoader } from "react-spinners"; 
import { useNavigate } from "react-router-dom";

const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2vw;
    justify-items: center;

    @media all and (max-width:479px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 1vw;
        display: grid;
    }
`;

const StyledTextBox = styled.div`
    width: auto;
    height: auto;
    margin-top: 5vw;
    display: flex;
    align-items: center;
    justify-content: center;

    h1 {
        color: #004076;
        margin-left: 10px;
    }
`;

function PokeCardList() {
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetPokemons();
    const { ref, inView } = useInView();
    const navigate = useNavigate();

    useEffect(() => {
        if (inView && hasNextPage && !isFetchingNextPage) {
            setTimeout(() => { fetchNextPage() }, 1000);
        }
    }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

    const handleCardClick = (pokemon) => {
        navigate("/detail", { state: { pokemonData: pokemon } });
    };

    return (
        <>
            <CardGrid>
                {data?.pages.flatMap((page) =>
                    page.map((pokemon) => (
                        <div key={pokemon.id} onClick={() => handleCardClick(pokemon)}>
                            <PokeCard image={pokemon.image} name={pokemon.name} />
                        </div>
                    ))
                )}
            </CardGrid>
            <StyledTextBox>
                <ClipLoader color="#004076" loading={true} size={30} />
                <h1 ref={ref}>포켓몬을 더 가져오고 있어요..</h1>
            </StyledTextBox>
        </>
    );
}

export default PokeCardList;
